import { SettlementFiscalAttributes } from 'src/app/models/settlement.model';

export function resolveSettlementFiscalAttributes(attributes: any): SettlementFiscalAttributes | undefined {
  const fiscalData = attributes?.settlement_fiscal_attributes ?? attributes?.settlement_fiscal;
  const fiscalResource = fiscalData?.data ?? fiscalData;
  const fiscalAttributes = fiscalResource?.attributes ?? fiscalResource;
  if (!fiscalAttributes) return undefined;

  return {
    id: fiscalResource?.id ?? fiscalAttributes?.id,
    rfc: fiscalAttributes?.rfc,
    razon_social: fiscalAttributes?.razon_social ?? fiscalAttributes?.business_name,
    zip_code: fiscalAttributes?.zip_code,
    regimen_fiscal: fiscalAttributes?.regimen_fiscal ?? fiscalAttributes?.tax_regime,
    uso_cfdi: fiscalAttributes?.uso_cfdi ?? fiscalAttributes?.cfdi_use
  };
}
